<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-05 15:24:20
 * @Description: 账号安全 关联账号
-->
<template>
	<div>
		<List :pagination="false" addTitle="" ref="table" :loading="loading" :columns="columns" :isChecked="false" :dataSource="dataSource">
			<template v-slot:isCommon="{ text }">
				<a-icon v-if="text == 1" type="check" style="color: #6BD31D;" />
				<a-icon v-else type="close" style="color: #FF3A39;" />
			</template>
			<!-- 操作按钮 record-->
			<template v-slot:action="{ record }">
				<a @click="handleEdit(record)" :disabled="record.isCommon == 1">{{ $t("home.account_related.btn") }}</a>
			</template>
		</List>
		<!-- 关联说明 -->
		<!-- <div class="relative-desc">
			<div>关联说明：</div>
			<p>已关联帐号，可以使用非帐号模式登录。</p>
		</div> -->
	</div>
</template>

<script>
import List from "@/components/public/list/ant";
import { commonAPI } from "@/apis";

export default {
	name: "relative",
	components: { List },
	data() {
		return {
			columns: [
				{ title: this.$t("base.table.account"), dataIndex: "username", align: "center" },
				{ title: this.$t("home.account_related.columns.create_time"), dataIndex: "createdDate", align: "center" },
				{ title: this.$t("home.account_related.columns.user_type"), dataIndex: "userType_dictText", align: "center" },
				{
					title: this.$t("home.account_related.columns.common_user"),
					dataIndex: "isCommon",
					align: "center",
					scopedSlots: { customRender: "isCommon" },
				},
				{ title: this.$t("base.table.action"), align: "center", scopedSlots: { customRender: "action" } },
			],
			dataSource: [],
			loading: false,
		};
	},
	created() {
		this.getList();
	},
	methods: {
		// 获取数据
		async getList() {
			this.loading = true;
			const { code, data, message } = await commonAPI.getAction("/config/profile/listOtherAccount");
			if (code == 0) {
				this.dataSource = data || [];
			} else {
				this.$message.error(message);
			}
			this.loading = false;
		},
		// 设置默认
		async handleEdit(record) {
			const { code, message } = await commonAPI.getAction(`/config/profile/editDefAccount/${record.username}`);
			if (code == 0) {
				this.$message.success(message);
				this.getList();
			} else {
				this.$message.error(message);
			}
		},
	},
};
</script>

<style scoped lang="less">
.relative-desc {
	margin-top: 30px;
	& > p:last-child {
		color: #999999;
		margin-top: 5px;
	}
}
</style>
